import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.property;

export const propertySelectors = {
    totalItems: createSelector(selector, (property) => property.total_items),
    totalPages: createSelector(selector, (property) => property.total_pages),
    currentPage: createSelector(selector, (property) => property.current_page),
    pageSize: createSelector(selector, (property) => property.page_size),
    nextPage: createSelector(selector, (property) => property.next_page),
    previousPage: createSelector(selector, (property) => property.previous_page),
    properties: createSelector(selector, (property) => property.data),
    propertyCategories: createSelector(selector, (property) => property.property_categories),
    propertyTypes: createSelector(selector, (property) => property.property_types),
    propertyOwners: createSelector(selector, (property) => property.property_owners),
    cities: createSelector(selector, (property) => property.cities),
    districts: createSelector(selector, (property) => property.districts),
    communes: createSelector(selector, (property) => property.communes),
    popularPlaces: createSelector(selector, (property) => property.popular_places),
    features: createSelector(selector, (property) => property.features),
    selectedPropertyDetail: createSelector(selector, (property) => property.selectedPropertyDetail),
}